module.exports = __webpack_public_path__ + "static/media/dad-girl.85ec1c0c.png";